enum EFileStatus {
  LOADING = 'loading',
  DELETING = 'deleting',
  SUCCESS = 'success',
  ERROR = 'error',
  DEFAULT = 'default',
}

export default EFileStatus;
